import i18n from '@/i18n/i18n'
import FarmerInvoiceService from '@/services/public/FarmerInvoiceService.js'

import { errorMessage } from '@/utilities/helpers'

import { ORDER_ERROR_MESSAGES } from '@/constants/errorMessages'

const { t } = i18n.global

export const namespaced = true

export const state = {
  order: null,
  invoice_pdf: null,
  late_fee_invoice_pdf: null,
  receipt_pdf: null,
  paid_promissory_note: null
}

export const mutations = {
  SET_ORDER(state, order) {
    state.order = order.data
  },
  SET_INVOICE_PDF(state, invoice) {
    state.invoice_pdf = invoice
  },
  SET_LATE_FEE_INVOICE_PDF(state, invoice) {
    state.late_fee_invoice_pdf = invoice
  },
  SET_RECEIPT_PDF(state, receipt) {
    state.receipt_pdf = receipt
  },
  SET_PAID_PROMISSORY_NOTE(state, paidPromissoryNote) {
    state.paid_promissory_note = paidPromissoryNote
  }
}

export const actions = {
  getOrder({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      FarmerInvoiceService.getOrder(params.orderId, params.tckn)
        .then(response => {
          commit('SET_ORDER', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:  ORDER_ERROR_MESSAGES.getInvoiceError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getInvoice({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      FarmerInvoiceService.getInvoice(params.orderId, params.tckn)
        .then(response => {
          commit('SET_INVOICE_PDF', response)
          resolve(response)
        })
        .catch(err => {
            const notification = {
              type: 'danger',
              message: t('store.shared.fetching_problem', {
                element: t('store.public.invoice.invoice')
              })
            }
            dispatch('notification/add', notification, {
              root: true
            })
            reject(err)
        })
    })
  },
  getLateFeeInvoice({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      FarmerInvoiceService.getLateFeeInvoice(params.orderId, params.tckn)
        .then(response => {
          commit('SET_LATE_FEE_INVOICE_PDF', response)
          resolve(response)
        })
        .catch(err => {
            const notification = {
              type: 'danger',
              message: t('store.shared.fetching_problem', {
                element: t('store.public.invoice.late_fee_invoice')
              })
            }
            dispatch('notification/add', notification, {
              root: true
            })
            reject(err)
        })
    })
  },
  getOrderReceipt({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      FarmerInvoiceService.getOrderReceipt(params.orderId, params.tckn)
          .then(response => {
            commit('SET_RECEIPT_PDF', response)
            resolve(response)
          })
          .catch(err => {
            const notification = {
              type: 'danger',
              message: t('store.shared.fetching_problem', {
                element: t('store.public.invoice.order_receipt')
              })
            }
            dispatch('notification/add', notification, {
              root: true
            })
            reject(err)
          })
    })
  },
  getPaidPromissoryNote({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      FarmerInvoiceService.getPaidPromissoryNote(params.orderId, params.tckn)
          .then(response => {
            commit('SET_PAID_PROMISSORY_NOTE', response)
            resolve(response)
          })
          .catch(err => {
            const notification = {
              type: 'danger',
              message: t('store.shared.fetching_problem', {
                element: t('store.public.invoice.order_receipt')
              })
            }
            dispatch('notification/add', notification, {
              root: true
            })
            reject(err)
          })
    })
  }
}
